// extracted by mini-css-extract-plugin
export default {"modal":"ze1XxgiuNn2fQKsA5tMc"};